import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { TableCell, TableRow } from "@/core/components/ui/table";

export const EmptyTable = () => {
  const { t } = useTypedTranslation();
  return (
    <TableRow>
      <TableCell
        colSpan={100}
        className="px-4 py-12 text-center font-bold uppercase text-muted-foreground sm:px-8 sm:py-24"
      >
        {t("noTableDataToDisplay")}
      </TableCell>
    </TableRow>
  );
};
